import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import './RelatedTools.css'
import { TOOLS } from './toolsData'
import { trackEvent } from '../../lib/analytics'

const RANDOM_COUNT = 6

const pickRandom = (list, count) => {
  const pool = [...list]
  const picked = []
  while (pool.length && picked.length < count) {
    const index = Math.floor(Math.random() * pool.length)
    picked.push(pool.splice(index, 1)[0])
  }
  return picked
}

const RelatedTools = ({ currentPath }) => {
  const suggestions = useMemo(
    () => pickRandom(TOOLS.filter((tool) => tool.to !== currentPath), RANDOM_COUNT),
    [currentPath],
  )

  if (suggestions.length === 0) return null

  return (
    <div className="related-tools">
      <h2>Outras ferramentas</h2>
      <div className="related-tools-grid">
        {suggestions.map((tool) => (
          <Link
            to={tool.to}
            className="related-tool-card"
            key={tool.to}
            onClick={() => trackEvent('related_tool_click', { tool: tool.title })}
          >
            <span className="related-tool-icon">
              <tool.icon aria-hidden="true" />
            </span>
            <span className="related-tool-text">
              <strong>{tool.title}</strong>
              <span>{tool.description}</span>
            </span>
          </Link>
        ))}
      </div>
      <Link to="/ferramentas" className="related-tools-all-link">
        Ver todas as ferramentas →
      </Link>
    </div>
  )
}

export default RelatedTools
